module.exports = __webpack_public_path__ + "img/flow-step-5.4cce63d.png";